import 'nodelist-foreach-polyfill';
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Report from '../components/report/Report.vue';
import reportViewerStore from '../components/report/store'

Vue.use(Vuex)
Vue.config.ignoredElements = [/^ion-/]
Vue.prototype.$axios = axios;
Vue.prototype.$csrfToken = document.querySelectorAll('meta[name="csrf-token"]')[0].content;

function ready () {
  initReports();
}

function initReports(){

  var el = document.querySelector('#report')
  if(!el){
    return
  }
  let reportProps = JSON.parse(el.dataset.config)
  let responseProps, leadProps
  let supportedLanguages = cogniclick.report.supportedLanguages
  let translations = cogniclick.report.translations
  if (el.dataset.response) {
    responseProps = JSON.parse(el.dataset.response)
  } else {
    responseProps = null
  }
  if (el.dataset.lead) {
    leadProps = el.dataset.lead
  } else {
    leadProps = null
  }
  let answers = null
  if (el.dataset.answers) {
    answers  = JSON.parse(el.dataset.answers)
  }
  const app = new Vue({
    el,
    store: new Vuex.Store(reportViewerStore),
    render: h => h(Report,
      {props:
        {
          cid: el.dataset.cid,
          uid: el.dataset.uid,
          config: reportProps,
          response: responseProps,
          lead: leadProps,
          translations: translations,
          supportedLanguages: supportedLanguages,
          answers: answers
        }
      })
  })
}

document.addEventListener('DOMContentLoaded', ready)